import { action, observable } from "mobx";

import apiUrl from "@const/apiUrl";
import baseState from "../../baseState";
import { joinUrl } from "@utils/index";

export default class deviceState extends baseState {
    @observable list = {};
    @action
    setList = data => this.list = data;

    getList = data => {
        return this.fetch({
            url: apiUrl.DEVICE.LIST,
            method: 'get',
            setState: "setList",
            data
        });
    }

    @observable detail = {};
    @action
    setDetail = data => this.detail = data;

    getDetail = data => {
        const { id } = data;
        return this.fetch({
            url: joinUrl(apiUrl.DEVICE.DETAIL, id),
            method: 'get',
            setState: "setDetail",
            data
        });
    }

    insert = data => this.fetch({ url: apiUrl.DEVICE.INSERT, method: 'post', data }); // 创建
    update = data => this.fetch({ url: apiUrl.DEVICE.UPDATE, method: 'post', data }); // 更新
    delete = id => this.fetch({ url: apiUrl.DEVICE.DELETE.replace("{id}", id), method: 'post', data: { id } }); // 删除
    activate = data => this.fetch({ url: apiUrl.DEVICE.ACTIVATE, method: 'post', data }); // 激活
}
